export const GOOGLE_MAPS_API_KEY = "AIzaSyCnZ6eGPMIw1VYCS8XqjbRtAcmMh0E6Hjs";

export const FONTS = `@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap');`;

export const GRAD = "linear-gradient(90deg, #FF69B4, #FFB347)";
export const PINK = "#FF69B4";
export const YELLOW = "#FFB347";
export const CREAM = "#FAF7F4";
export const DARK = "#1a1a1a";
export const CARD_BORDER = "#FFE0F0";
export const CARD_BG = "#FFF0F8";

export const AFFIRMATIONS = [
  "you are that girl 💕",
  "slay every single step",
  "london is your runway",
  "main character energy only",
  "this walk is your reset",
  "you showed up. that's everything.",
  "hot girl walks build empires",
  "move your body, clear your mind",
  "you're literally glowing rn",
  "this is your villain era. walk it out.",
  "every step is a slay",
  "london girlies rise",
  "you ate and left no crumbs",
  "that girl energy activated",
  "walk like you own the city",
];
